export default __webpack_public_path__ + "static/media/user_dashboard_2.f4b543c4.png";